module.exports = __webpack_public_path__ + "img/team-04.dbda21ea.jpg";